<header class="pc-header coded-header" [class.header-collapsed]="navCollapsed">
  <app-nav-logo [navCollapsed]="navCollapsed" />
  <div class="header-wrapper">
    <app-nav-left (NavCollapsedMob)="navCollapseMob()" />
    <app-nav-right />
  </div>
</header>
